<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useAdditionalFieldStore} from "@/stores/AdditionalField";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$router, $i18n} = useTools();

        const {loading, total} = useSharedData();

        const securityStore = useSecurityStore();
        const additionalFieldStore = useAdditionalFieldStore();

        const search = ref(null);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action"
            },
            {
                text: $i18n.t('common.label'),
                sortable: true,
                value: "label"
            },
            {
                text: $i18n.t('common.module'),
                sortable: true,
                value: "module"
            },
            {
                text: $i18n.t('common.field'),
                sortable: true,
                value: "field"
            },
            {
                text: $i18n.t('common.required'),
                sortable: true,
                value: "required"
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'additional_fields.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_GENERAL_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'additional_fields.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/additionalFields').then((response) => {
                additionalFieldStore.setAdditionalFields(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "additional_fields.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            additionalFieldStore,
            loading,
            headers,
            actions,
            search,
            total,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.additional_fields')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_GENERAL_PARAM']"
                    @press="$router.push({ name: 'additional_fields.add' })"
                />
            </template>

            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="additionalFieldStore.additionalFields"
                    :total="total"
                    :search="search"
                    sort-by="order"
                    @rowDbClick="view"
                >
                    <template v-slot:item.module="{ item }">
                        <w-chip color="blue darken-2" :text="$t(`additional_field.${item.module}`)"/>
                    </template>
                    <template v-slot:item.field="{ item }">
                        <w-chip color="teal" :text="$t(`additional_field.field.${item.field}`)"/>
                    </template>
                    <template v-slot:item.required="{ item }">
                        <w-chip :color="item.required ? 'teal' : 'red'" text="Requis"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>